export default __webpack_public_path__ + "static/media/banner-39.d16bfc70.jpg";